import React from 'react'
import { withRouter } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Dialog } from 'primereact/dialog'
import { InputNumber } from 'primereact/inputnumber'
import { InputTextarea } from 'primereact/inputtextarea'
import { Toolbar } from 'primereact/toolbar'

import Card from '../../components/card'
import CustomCalendar from '../../components/calendar/customCalendar'
import InputChooseProduct from '../../components/product/inputChooseProduct'
import SelectMenu from '../../components/selectMenu'
import TableFilters from '../../components/tableFilters'
import CheckBoxComponent from '../../components/relatorios/checkBoxComponent'
import AuthService from '../../app/service/authService'
import ConstantsUtil from '../../context/constantsUtil'
import GeneralServices from '../../app/service/generalServices'
import HandleErrorService from '../../app/service/handleErrorService'
import LancamentoFechamentoCaixaService from '../../app/service/contasAReceber/lancamentoFechamentoCaixaService'
import RequisicaoEstoqueService from '../../app/service/estoque/requisicaoEstoqueService'
import * as popUp from '../../components/toastr'

class RequisicaoEstoque extends React.Component {

    constructor() {
        super()
        this.dt = React.createRef()
        this.tableFilters = new TableFilters()
        this.lancamentoFechamentoCaixaService = new LancamentoFechamentoCaixaService()
        this.requisicaoEstoqueService = new RequisicaoEstoqueService()
    }

    state = {
        selectedProduct: '',
        selectedProductLabel: '',
        inputProductErrorClass: '',
        errorProductMessage: '',

        quantidade: null,
        inputQuantidadeErrorClass: '',
        errorQuantidadeMessage: '',

        itens: [],

        departamentoRequisicaoList: [],
        selectedDepartamentoRequisicao: '',
        inputDepartamentoRequisicaoErrorClass: '',
        errorDepartamentoRequisicaoMessage: '',

        dataHoraNecessidade: '',
        dataHoraNecessidadeView: '',
        turnoNecessidade: '',
        inputTurnoNecessidadeErrorClass: '',

        efetivarSaidaAgora: false,
        mensagem: '',
        requisicoes: [],
        selectedDataHoraRequisicao: null,
        selectedDataHoraNecessidade: null,
        selectedTurnoNecessidade: null,
        selectedDepartamentoRequisicaoFiltro: null,
        selectedEmailUsuario: null,
        selectedStatus: null,
        selectedQuantidadeItens: null,
        selectedMensagem: null,
        requisicaoSelecionada: null,
        visualizacaoDialog: false,
        loading: false,
    }

    componentDidMount() {
        this.searchDepartamentos()

        if(this.podeAtenderRequisicao()){
            this.search()
        }
    }

    searchDepartamentos = () => {
        this.requisicaoEstoqueService.searchDepartamentos()
        .then(response => {
            const departamentoRequisicaoList = [
                {label: response.data.length ? 'Selecione' : 'Seu usuário não possui permissão em nenhum departamento. Solicite seu acesso ao administrador.', value: ''},
                ...response.data.map(departamento => {
                    return {
                        label: departamento.nome,
                        value: departamento.id
                    }
                })
            ]

            this.setState({departamentoRequisicaoList, selectedDepartamentoRequisicao: ''})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    podeAtenderRequisicao = () => {
        const perfil = AuthService.getPerfil()
        return perfil.isAdmin || perfil.isOperador || perfil.isOperadorBancario
    }

    getTurnoNecessidadeList = () => {
        return this.lancamentoFechamentoCaixaService.turnoArray
            .filter(turno => turno.value !== 'UNICO')
    }

    handleChange = (event) => {
        const name = event.target.name
        const value = event.target.value
        this.setState({[name]: value})
    }

    handleDepartamentoChange = (event) => {
        this.setState({
            selectedDepartamentoRequisicao: event.target.value,
            inputDepartamentoRequisicaoErrorClass: '',
            errorDepartamentoRequisicaoMessage: '',
        })
    }

    handleTurnoChange = (event) => {
        this.setState({
            turnoNecessidade: event.target.value,
            inputTurnoNecessidadeErrorClass: '',
        })
    }

    handleEfetivarSaidaAgoraChange = (checked) => {
        this.setState({efetivarSaidaAgora: checked})
    }

    handleSelectionProductChange = (product) => {
        this.setState({
            selectedProduct: product,
            selectedProductLabel: product ? product.descricao : '',
            inputProductErrorClass: '',
            errorProductMessage: '',
        })
    }

    handleDateChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: GeneralServices.convertJSDateToBrDate(value) })
        await this.setState({ [name + 'View']: value })
    }

    handleQuantidadeChange = (event) => {
        this.setState({
            quantidade: event.value,
            inputQuantidadeErrorClass: '',
            errorQuantidadeMessage: '',
        })
    }

    resetValidation = () => {
        this.setState({
            inputProductErrorClass: '',
            errorProductMessage: '',
            inputQuantidadeErrorClass: '',
            errorQuantidadeMessage: '',
            inputDepartamentoRequisicaoErrorClass: '',
            errorDepartamentoRequisicaoMessage: '',
            inputTurnoNecessidadeErrorClass: '',
        })
    }

    checkItemForm = () => {
        let check = true

        if(!this.state.selectedProduct){
            this.setState({
                inputProductErrorClass: ConstantsUtil.bootstrapInputErrorClass,
                errorProductMessage: 'Informe o produto',
            })
            check = false
        }

        if(!this.state.quantidade || this.state.quantidade <= 0){
            this.setState({
                inputQuantidadeErrorClass: ConstantsUtil.primereactInputErrorClass,
                errorQuantidadeMessage: 'Informe a quantidade',
            })
            check = false
        }

        return check
    }

    addItem = () => {
        this.resetValidation()

        if(!this.checkItemForm()){
            return
        }

        const product = this.state.selectedProduct
        const itens = this.state.itens.filter(item => item.idProduto !== product.id)

        itens.push({
            idProduto: product.id,
            produto: product,
            descricaoProduto: product.descricao,
            quantidade: this.state.quantidade,
        })

        this.setState({
            itens,
            selectedProduct: '',
            selectedProductLabel: '',
            quantidade: null,
        })
    }

    removeItem = (rowData) => {
        this.setState({itens: this.state.itens.filter(item => item.idProduto !== rowData.idProduto)})
    }

    checkForm = () => {
        let check = true

        if(!this.state.itens.length){
            popUp.warningPopUp('Informe ao menos um produto.')
            check = false
        }

        if(!this.state.selectedDepartamentoRequisicao){
            this.setState({
                inputDepartamentoRequisicaoErrorClass: ConstantsUtil.bootstrapInputErrorClass,
                errorDepartamentoRequisicaoMessage: 'Informe o departamento',
            })
            check = false
        }

        if(!this.state.turnoNecessidade){
            this.setState({inputTurnoNecessidadeErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        return check
    }

    buildRequisicaoEstoque = () => {
        return {
            idDepartamentoRequisicao: this.state.selectedDepartamentoRequisicao,
            dataHoraNecessidade: this.state.dataHoraNecessidade || null,
            turnoNecessidade: this.state.turnoNecessidade,
            efetivarSaidaAgora: this.podeAtenderRequisicao() && this.state.efetivarSaidaAgora,
            mensagem: this.state.mensagem,
            itens: this.state.itens.map(item => {
                return {
                    idProduto: item.idProduto,
                    quantidade: item.quantidade,
                }
            })
        }
    }

    resetForm = () => {
        this.setState({
            selectedProduct: '',
            selectedProductLabel: '',
            quantidade: null,
            itens: [],
            selectedDepartamentoRequisicao: '',
            dataHoraNecessidade: '',
            dataHoraNecessidadeView: '',
            turnoNecessidade: '',
            efetivarSaidaAgora: false,
            mensagem: '',
        })
        this.resetValidation()
    }

    search = () => {
        if(!this.podeAtenderRequisicao()){
            return
        }

        this.setState({loading: true})
        this.requisicaoEstoqueService.search()
        .then(response => {
            const requisicoes = response.data.map(requisicao => {
                return {
                    ...requisicao,
                    quantidadeItens: requisicao.itens ? requisicao.itens.length : 0
                }
            })
            this.setState({requisicoes})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    save = () => {
        this.resetValidation()

        if(!this.checkForm()){
            return
        }

        this.setState({loading: true})
        this.requisicaoEstoqueService.save(this.buildRequisicaoEstoque())
        .then(() => {
            popUp.successPopUp('Requisição de estoque salva com sucesso.')
            this.resetForm()
            if(this.podeAtenderRequisicao()){
                this.search()
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    openVisualizacaoDialog = (requisicao) => {
        this.setState({
            requisicaoSelecionada: requisicao,
            visualizacaoDialog: true
        })
    }

    hideVisualizacaoDialog = () => {
        this.setState({
            requisicaoSelecionada: null,
            visualizacaoDialog: false
        })
    }

    efetivarRequisicaoSelecionada = () => {
        const requisicao = this.state.requisicaoSelecionada

        if(!requisicao){
            return
        }

        this.setState({loading: true})
        this.requisicaoEstoqueService.efetivar(requisicao.id)
        .then(() => {
            popUp.successPopUp('Requisição efetivada com sucesso.')
            this.hideVisualizacaoDialog()
            this.search()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    cancelarRequisicaoSelecionada = () => {
        const requisicao = this.state.requisicaoSelecionada

        if(!requisicao){
            return
        }

        this.setState({loading: true})
        this.requisicaoEstoqueService.cancelar(requisicao.id)
        .then(() => {
            popUp.successPopUp('Requisição cancelada com sucesso.')
            this.hideVisualizacaoDialog()
            this.search()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    render() {
        const renderEfetivarSaidaAgora = () => {
            if(!this.podeAtenderRequisicao()){
                return
            }

            return (
                <div className="col-md-3 d-flex align-items-center" style={{paddingTop: '28px'}}>
                    <CheckBoxComponent
                        label="Efetivar saída agora"
                        checked={this.state.efetivarSaidaAgora}
                        handleCheckBoxChange={this.handleEfetivarSaidaAgoraChange}
                    />
                </div>
            )
        }

        const renderRemoveItemButton = (rowData) => {
            return (
                <Button
                    icon="pi pi-trash"
                    className="p-button-danger"
                    onClick={() => this.removeItem(rowData)}
                />
            )
        }

        const renderQuantidadeItens = (rowData) => {
            return rowData.quantidadeItens
        }

        const renderStatus = (rowData) => {
            if(rowData.status === 'EFETIVADA'){
                return <span className="badge badge-success">EFETIVADA</span>
            }

            if(rowData.status === 'CANCELADA'){
                return <span className="badge badge-danger">CANCELADA</span>
            }

            return <span className="badge badge-warning">PENDENTE</span>
        }

        const renderActionBody = (rowData) => {
            return (
                <Button
                    icon="pi pi-eye"
                    tooltip="Visualizar"
                    tooltipOptions={{position: 'top'}}
                    className="p-button-rounded p-button-success p-mr-2 small-font"
                    style={{maxHeight: '25px', maxWidth: '25px'}}
                    onClick={() => this.openVisualizacaoDialog(rowData)}
                />
            )
        }

        const renderProdutoItem = (rowData) => {
            return rowData.produto ? rowData.produto.descricao : ''
        }

        const renderCodigoProdutoItem = (rowData) => {
            return rowData.produto ? rowData.produto.codigo : ''
        }

        const renderQuantidadeEstoqueItem = (rowData) => {
            return rowData.quantidadeEstoque !== null && rowData.quantidadeEstoque !== undefined ? rowData.quantidadeEstoque : 0
        }

        const renderVisualizacaoDialogFooter = () => {
            const requisicao = this.state.requisicaoSelecionada
            const isPendente = requisicao && requisicao.status === 'PENDENTE'

            return (
                <>
                    {isPendente && (
                        <Button
                            label="Efetivar saída"
                            icon="pi pi-check"
                            className="p-button-success"
                            onClick={this.efetivarRequisicaoSelecionada}
                            disabled={this.state.loading}
                        />
                    )}
                    {isPendente && (
                        <Button
                            label="Cancelar requisição"
                            icon="pi pi-ban"
                            className="p-button-danger"
                            onClick={this.cancelarRequisicaoSelecionada}
                            disabled={this.state.loading}
                        />
                    )}
                    <Button
                        label="Fechar"
                        icon="pi pi-times"
                        className="p-button-text"
                        onClick={this.hideVisualizacaoDialog}
                        disabled={this.state.loading}
                    />
                </>
            )
        }

        const renderVisualizacaoDialog = () => {
            const requisicao = this.state.requisicaoSelecionada

            if(!requisicao){
                return
            }

            return (
                <Dialog
                    header="Requisição de Estoque"
                    visible={this.state.visualizacaoDialog}
                    style={{ width: '70vw' }}
                    modal
                    footer={renderVisualizacaoDialogFooter()}
                    onHide={this.hideVisualizacaoDialog}
                >
                    <div className="row">
                        <div className="col-md-2">
                            <strong>Status</strong>
                            <div>{renderStatus(requisicao)}</div>
                        </div>
                        <div className="col-md-3">
                            <strong>Data requisição</strong>
                            <div>{requisicao.dataHoraRequisicao || '-'}</div>
                        </div>
                        <div className="col-md-3">
                            <strong>Data necessidade</strong>
                            <div>{requisicao.dataHoraNecessidade || '-'}</div>
                        </div>
                        <div className="col-md-2">
                            <strong>Turno</strong>
                            <div>{requisicao.turnoNecessidade || '-'}</div>
                        </div>
                        <div className="col-md-2">
                            <strong>Data saída</strong>
                            <div>{requisicao.dataHoraSaida || '-'}</div>
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-md-3">
                            <strong>Departamento</strong>
                            <div>{requisicao.departamentoRequisicao ? requisicao.departamentoRequisicao.nome : '-'}</div>
                        </div>
                        <div className="col-md-6">
                            <strong>Usuário</strong>
                            <div>{requisicao.emailUsuario || '-'}</div>
                        </div>
                        <div className="col-md-3">
                            <strong>Mensagem</strong>
                            <div>{requisicao.mensagem || '-'}</div>
                        </div>
                    </div>

                    <br />

                    <DataTable
                        value={requisicao.itens}
                        className="p-datatable-sm small-font"
                        emptyMessage="Nenhum produto informado"
                    >
                        <Column body={renderCodigoProdutoItem} header="Código" style={{width: '120px'}} />
                        <Column body={renderProdutoItem} header="Produto" />
                        <Column field="quantidade" header="Quantidade solicitada" style={{width: '160px'}} />
                        <Column body={renderQuantidadeEstoqueItem} header="Quantidade em estoque" style={{width: '170px'}} />
                    </DataTable>
                </Dialog>
            )
        }

        const renderRequisicoesTable = () => {
            if(!this.podeAtenderRequisicao()){
                return
            }

            const dataHoraRequisicaoFilterElement = this.tableFilters.renderTableFilter(
                this.dt,
                this.state.selectedDataHoraRequisicao,
                this.state.requisicoes,
                "selectedDataHoraRequisicao",
                (name, value) => this.setState({[name]: value}),
                'dataHoraRequisicao',
                '100%',
                "Data"
            )

            const dataHoraNecessidadeFilterElement = this.tableFilters.renderTableFilter(
                this.dt,
                this.state.selectedDataHoraNecessidade,
                this.state.requisicoes,
                "selectedDataHoraNecessidade",
                (name, value) => this.setState({[name]: value}),
                'dataHoraNecessidade',
                '100%',
                "Data"
            )

            const emailUsuarioFilterElement = this.tableFilters.renderTableFilter(
                this.dt,
                this.state.selectedEmailUsuario,
                this.state.requisicoes,
                "selectedEmailUsuario",
                (name, value) => this.setState({[name]: value}),
                'emailUsuario',
                '100%',
                "Usuário"
            )

            const turnoNecessidadeFilterElement = this.tableFilters.renderTableFilter(
                this.dt,
                this.state.selectedTurnoNecessidade,
                this.state.requisicoes,
                "selectedTurnoNecessidade",
                (name, value) => this.setState({[name]: value}),
                'turnoNecessidade',
                '100%',
                "Turno"
            )

            const departamentoRequisicaoFilterElement = this.tableFilters.renderTableFilter(
                this.dt,
                this.state.selectedDepartamentoRequisicaoFiltro,
                this.state.requisicoes,
                "selectedDepartamentoRequisicaoFiltro",
                (name, value) => this.setState({[name]: value}),
                'departamentoRequisicao.nome',
                '100%',
                "Departamento"
            )

            const statusFilterElement = this.tableFilters.renderTableFilter(
                this.dt,
                this.state.selectedStatus,
                this.state.requisicoes,
                "selectedStatus",
                (name, value) => this.setState({[name]: value}),
                'status',
                '100%',
                "Status"
            )

            const quantidadeItensFilterElement = this.tableFilters.renderTableFilter(
                this.dt,
                this.state.selectedQuantidadeItens,
                this.state.requisicoes,
                "selectedQuantidadeItens",
                (name, value) => this.setState({[name]: value}),
                'quantidadeItens',
                '100%',
                "Itens"
            )

            const mensagemFilterElement = this.tableFilters.renderTableFilter(
                this.dt,
                this.state.selectedMensagem,
                this.state.requisicoes,
                "selectedMensagem",
                (name, value) => this.setState({[name]: value}),
                'mensagem',
                '100%',
                "Mensagem"
            )

            const leftToolbarTemplate = () => {
                return (
                    <Button
                        label="Atualizar"
                        icon="pi pi-refresh"
                        className="p-button-primary"
                        style={{maxHeight: '30px'}}
                        onClick={this.search}
                    />
                )
            }

            const rightToolbarTemplate = () => {
                return <React.Fragment />
            }

            const totalRequisicoesPendentes = this.state.requisicoes.filter(requisicao => requisicao.status === 'PENDENTE').length

            return (
                <Card title="Requisições">
                    <div className="mb-2">
                        <strong>Requisições pendentes: </strong>{totalRequisicoesPendentes}
                    </div>
                    <div className="datatable-crud-demo">
                        <div className="card">
                            <Toolbar className="p-mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate} />
                            <DataTable
                                ref={this.dt}
                                value={this.state.requisicoes}
                                className="p-datatable-sm small-font"
                                rowHover
                                scrollable
                                style={{ maxWidth: '100vw' }}
                                scrollHeight="500px"
                                emptyMessage="Nenhuma requisição encontrada"
                                loading={this.state.loading}
                                dataKey="id"
                                paginator
                                rows={ConstantsUtil.initialTableQuantityOption}
                                paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.state.requisicoes ? this.state.requisicoes.length : '')}
                                currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} requisições"
                            >
                                <Column field="dataHoraRequisicao" header="Data requisição" sortable style={{width: '160px'}} filter filterElement={dataHoraRequisicaoFilterElement} />
                                <Column field="dataHoraNecessidade" header="Data necessidade" sortable style={{width: '160px'}} filter filterElement={dataHoraNecessidadeFilterElement} />
                                <Column field="turnoNecessidade" header="Turno" sortable style={{width: '120px'}} filter filterElement={turnoNecessidadeFilterElement} />
                                <Column field="departamentoRequisicao.nome" header="Departamento" sortable style={{width: '180px'}} filter filterElement={departamentoRequisicaoFilterElement} />
                                <Column field="emailUsuario" header="Usuário" sortable style={{width: '220px'}} filter filterElement={emailUsuarioFilterElement} />
                                <Column field="status" body={renderStatus} header="Status" sortable style={{width: '120px'}} filter filterElement={statusFilterElement} />
                                <Column field="quantidadeItens" body={renderQuantidadeItens} header="Itens" sortable style={{width: '90px'}} filter filterElement={quantidadeItensFilterElement} />
                                <Column field="mensagem" header="Mensagem" sortable style={{width: '250px'}} filter filterElement={mensagemFilterElement} />
                                <Column header="Ações" body={renderActionBody} style={{width: '80px'}} />
                            </DataTable>
                        </div>
                    </div>
                </Card>
            )
        }

        return (
            <div className="bs-docs-section">
                <Card title="Requisição de Estoque">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-2">
                                <label htmlFor="departamentoRequisicao">Departamento</label>
                                <SelectMenu
                                    id="departamentoRequisicao"
                                    name="departamentoRequisicao"
                                    className={"form-control " + this.state.inputDepartamentoRequisicaoErrorClass}
                                    value={this.state.selectedDepartamentoRequisicao}
                                    list={this.state.departamentoRequisicaoList}
                                    onChange={this.handleDepartamentoChange}
                                />
                                <small className="p-error">{this.state.errorDepartamentoRequisicaoMessage}</small>
                            </div>
                            <div className="col-md-2">
                                <CustomCalendar
                                    label="Data da necessidade"
                                    id="dataHoraNecessidadeRequisicaoEstoque"
                                    noHTMLFormat
                                    value={this.state.dataHoraNecessidadeView}
                                    name="dataHoraNecessidade"
                                    onChange={this.handleDateChange}
                                />
                            </div>
                            <div className="col-md-2">
                                <label htmlFor="turnoNecessidade">Turno</label>
                                <SelectMenu
                                    id="turnoNecessidade"
                                    name="turnoNecessidade"
                                    className={"form-control " + this.state.inputTurnoNecessidadeErrorClass}
                                    value={this.state.turnoNecessidade}
                                    list={this.getTurnoNecessidadeList()}
                                    onChange={this.handleTurnoChange}
                                />
                                <div className="invalid-feedback">{ConstantsUtil.errorTurnoMessage}</div>
                            </div>
                            {renderEfetivarSaidaAgora()}
                        </div>

                        <br />

                        <div className="row">
                            <div className="col-md-4">
                                <InputChooseProduct
                                    noHTMLFormat
                                    productFilter={{apenasProdutosControlados: true}}
                                    selectedProductLabel={this.state.selectedProductLabel}
                                    inputProductErrorClass={this.state.inputProductErrorClass}
                                    errorProductMessage={this.state.errorProductMessage}
                                    handleSelectionChange={this.handleSelectionProductChange}
                                />
                            </div>
                            <div className="col-md-2">
                                <label htmlFor="quantidade" style={{display: 'block'}}>Quantidade</label>
                                <InputNumber
                                    className={this.state.inputQuantidadeErrorClass}
                                    name="quantidade"
                                    inputId="quantidade"
                                    value={this.state.quantidade}
                                    onValueChange={this.handleQuantidadeChange}
                                    mode="decimal"
                                    locale="pt-BR"
                                    minFractionDigits={2}
                                />
                                <small className="p-error">{this.state.errorQuantidadeMessage}</small>
                            </div>
                            <div className="col-md-2" style={{paddingTop: '24px'}}>
                                <Button
                                    label="Adicionar"
                                    icon="pi pi-plus"
                                    onClick={this.addItem}
                                />
                            </div>
                        </div>

                        <br />

                        <DataTable value={this.state.itens} emptyMessage="Nenhum produto informado">
                            <Column field="descricaoProduto" header="Produto" />
                            <Column field="quantidade" header="Quantidade" />
                            <Column body={renderRemoveItemButton} header="Ações" />
                        </DataTable>

                        <br />

                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="mensagem" style={{display: 'block'}}>Mensagem</label>
                                <InputTextarea
                                    id="mensagem"
                                    name="mensagem"
                                    value={this.state.mensagem}
                                    onChange={this.handleChange}
                                    rows={5}
                                    cols={60}
                                    autoResize
                                />
                            </div>
                        </div>

                        <br />

                        <Button
                            label="Salvar Requisição"
                            icon="pi pi-save"
                            onClick={this.save}
                            disabled={this.state.loading}
                        />
                    </div>
                </Card>
                {renderRequisicoesTable()}
                {renderVisualizacaoDialog()}
                <div className="d-flex "/>
            </div>
        )
    }

}

export default withRouter(RequisicaoEstoque)
